import { Serializable } from './serializable.class';
import { UlbIMSI } from './ulb-imsi.class';

export class UlbIMSIPool extends Serializable {
  id: string;
  amount: number;
  name: string;
  group: string;
  status: UlbIMSIPoolStatus;
  accountId: string;
  ownership: Array<string>;
  profileFamily: string;
  network: string;
  hasActionFailed: boolean;
  imsis: UlbIMSI[];
  accountName: string;
  productId: string;

  public getResourceName(): string {
    return 'ulb/imsi-pool';
  }

  public getExportPath(): string {
    return this.getBulkPath().substring(0, this.getBulkPath().length - 4);
  }

  public getIdKey(): string {
    return 'id';
  }
}

export enum UlbIMSIPoolStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  DEACTIVATING = 'deactivating',
  ACTIVATING = 'activating',
  TERMINATED = 'terminated',
  TERMINATING = 'terminating',
  UNKNOWN = 'unknown',
}
